var es = {
    translation: {
        button: {
            backToAccountManager: 'Regresar al Administrador de Cuenta',
            requestRefundCheck: 'Solicitar un cheque de reembolso',
            back: 'Atrás',
            close: 'Cerrar',
            submit: 'Enviar',
            manageProfile: 'Administrar Perfil'
        },
        drawer: {
            drawerHeading: 'Administre el Saldo a Su Favor'
        },
        text: {
            startAChat: 'inicie un chat',
            requestARefund: 'Para descubrir cómo puede solicitar un reembolso, por favor ',
            requestSubmitted: 'Solicitud de Reembolso Enviada',
            requestInProgress: 'Solicitud de reembolso en curso',
            requestSuccessfullySubmitted: 'La solicitud de Reembolso ha sido enviada exitosamente',
            refundRequestDetails: 'Detalles de la Solicitud de Reembolso',
            requestRefundCheck: 'Su cuenta debería actualizarse con la solicitud de su reembolso dentro de 24 horas.  Recibirá su cheque de reembolso en un plazo de {{duration}}.',
            duration: '7 a 15 días hábiles',
            requestRefundThankYou: 'Gracias por su solicitud',
            amount: 'Monto',
            address: 'Dirección',
            wrongAddress: "\u00BFEs la direcci\u00F3n equivocada? Actual\u00EDcela en <manageProfileLink>{{manageProfileLinkText}}</manageProfileLink> y luego vuelva a empezar su solicitud de reembolso."
        },
        error: {
            header: 'Lo sentimos, algo salió mal.',
            subText: 'Cierre esta página y vuelva a intentarlo más tarde.',
            networkHeading: 'Tenemos problemas para recuperar esta información',
            networkMessage: 'Por favor, intente nuevamente más tarde.'
        },
        title: {
            manageBalanceOption: 'Administre el Saldo a Su Favor'
        },
        header: {
            theseOptionsText: 'estas opciones',
            theOptionText: 'la opción',
            applyCurrentBalance: 'Por favor, revise {{optionText}} sobre su saldo de {{currentBalance}}.',
            reviewCurrentBalance: 'Por favor, revise estas opciones sobre su saldo de',
            applyNextPurchase: 'Ahorre su crédito para una compra futura',
            requestRefundCheck: 'Solicitar un cheque de reembolso',
            reviewRefundRequest: 'Revise su solicitud de reembolso antes de enviar.'
        },
        subtext: {
            receiveRefundCheckAccessDeniedText: 'Para saber cómo puede solicitar un reembolso, ',
            onlineChatButton: 'utilice el Chat en Línea',
            receiveRefundCheck: 'Verificaremos su dirección y le enviaremos un cheque en un plazo de 7 a 15 días hábiles.',
            applyCurrentBalanceAutomatically: 'Su saldo actual se aplicará automáticamente a su próxima compra.',
            requestRefundCheck: 'Su solicitud puede demorar hasta 24 horas para reflejarse en su cuenta y recibirá un cheque de reembolso entre {{duration}}.',
            duration: '7 y 15 días hábiles a partir de su solicitud original'
        },
        mocks: {
            beginLogin: 'Iniciar sesión',
            logout: 'cerrar sesión',
            clientId: 'Ingrese una identificación de cliente',
            environment: 'Elige un entorno',
            accountEnding: 'Cuenta que termina en {{accountLast4}}',
            cardAccountEnding: 'Tarjeta para cuenta que termina en {{accountLast4}}',
            currentBalance: 'Saldo Actual',
            availableToSpend: 'Disponible para gastar',
            totalMinimumPayment: 'Pago Mínimo Total',
            paymentDueDate: 'Fecha de vencimiento del pago',
            makeAPayment: 'Realizar un pago'
        },
        logout: {
            pageTitle: 'Se ha cerrado la sesión',
            cardTitle: 'Gracias por administrar sus cuentas de Synchrony.',
            cardDescription: 'Se ha cerrado la sesión de forma segura.',
            button: 'INICIE SESIÓN DE NUEVO'
        }
    }
};
export default es;
